import { z } from 'zod';
import { DENOMINACIONES } from '../reglas/conteo.js';

/**
 * Los esquemas validan la forma en el formulario. La autoridad sigue estando en
 * Postgres, y por eso los mensajes son los codigos del contrato: la pantalla
 * traduce un solo diccionario, venga el rechazo del navegador o del servidor.
 */
const montoCop = z.number().int('E_MONTO_NEGATIVO').nonnegative('E_MONTO_NEGATIVO');

export const esquemaDesglose = z.object({
  efectivo: montoCop,
  tarjeta: montoCop,
  transferencia: montoCop,
});

export const esquemaVentaJornada = z
  .object({
    brutoCop: montoCop,
    descuentoCop: montoCop,
    desglose: esquemaDesglose,
  })
  .refine((v) => v.descuentoCop <= v.brutoCop, {
    message: 'E_DESCUENTO_EXCEDE_BRUTO',
    path: ['descuentoCop'],
  })
  .refine(
    (v) =>
      v.desglose.efectivo + v.desglose.tarjeta + v.desglose.transferencia ===
      v.brutoCop - v.descuentoCop,
    { message: 'E_DESGLOSE_NO_CUADRA', path: ['desglose'] },
  );

const denominacionesValidas = DENOMINACIONES.map(String);

export const esquemaConteo = z.object({
  denominaciones: z.record(
    z.string().refine((k) => denominacionesValidas.includes(k), {
      message: 'E_ASIENTO_NO_PERMITIDO',
    }),
    z.number().int('E_MONTO_NEGATIVO').nonnegative('E_MONTO_NEGATIVO'),
  ),
  revelar: z.boolean().optional(),
  nota: z.string().optional(),
});

export const esquemaCierre = z.object({
  jornadaId: z.string().uuid(),
  idempotencyKey: z.string().uuid(),
});

export type EntradaVentaJornada = z.infer<typeof esquemaVentaJornada>;
export type EntradaConteo = z.infer<typeof esquemaConteo>;
export type EntradaCierre = z.infer<typeof esquemaCierre>;
